export default {
    getCurrentUser: (state) => state.currentUser
}
